import img1 from '~/assets/images/scanner.svg';
import img2 from '~/assets/images/euro.svg';

const preloadImage = (url) => {
  const img = new Image();
  img.src = url;
};

[img1, img2].forEach(url => preloadImage(url));
